import React from 'react';
import PropTypes from 'prop-types';
import { isDropdownItemActive, isServiceActiveByPathname } from '../utils/pseudoRouter';
import DropdownItem from './DropdownItem';
import {
  getProductsURL,
  voidLinkAction,
  linkActionNewTarget,
  checkGlobalService,
  getCurrentServiceURL,
} from '../utils/commons';
import Dropdown from './Dropdown';
import locales from '../locales';
import env from './../environments/index';

const MenuElement = ({
  menuBlock,
  lang,
  preventDefaultLinks,
  expandSidebar,
  companyId,
  isEmBlue,
}) => {
  const langPrefix = `globalSidebar.mainMenu.${menuBlock.service}.`;
  const langPrefixItems = langPrefix + 'items.';
  const t = locales(lang);
  const checkAllowPremissionsByRol = (rolId, roles) => {
    if (roles === '*') return true;
    return roles && roles.split(',').includes(rolId);
  };

  const checkAllowPremissionsByEnvironments = (service, serviceTitle) => {
    return (
      typeof env.services[service][serviceTitle] === 'undefined' ||
      env.services[service][serviceTitle] === null ||
      env.services[service][serviceTitle]
    );
  };

  const checkAllowPremissionsByMaster = (item, serviceItem, companyId) => {
    return (
      typeof item.isMasterNotAllow === 'undefined' ||
      (serviceItem.properties &&
        serviceItem.properties.companies &&
        serviceItem.properties.companies.filter(company => {
          return company && !company.isMaster && company.id && company.id === companyId;
        }).length > 0)
    );
  };

  const checkAllowPremissionsByType = (item, serviceItem) => {
    return (
      typeof item.typeNotAllow === 'undefined' ||
      (serviceItem.properties &&
        serviceItem.properties.type &&
        !item.typeNotAllow.split(',').includes(serviceItem.properties.type))
    );
  };

  const getPath = (service, item) => {
    const { path, ownPath } = item;
    if (typeof ownPath === 'undefined') return path;
    const currentHostName = window.location.hostname;
    return getCurrentServiceURL(service).includes(currentHostName) ? ownPath : path;
  };

  const getMenuItems = () => {
    const { items, service, hasToShowCompanyInUrl, serviceItem } = menuBlock;
    return items.map(item => {
      const { roles, titleKey, hasIcon } = item;
      if (!checkAllowPremissionsByRol(serviceItem.rolId, roles)) return;
      if (!checkAllowPremissionsByEnvironments(service, titleKey)) return;
      if (!checkAllowPremissionsByType(item, serviceItem)) return;
      if (!checkAllowPremissionsByMaster(item, serviceItem, companyId)) return;

      const isActive = isDropdownItemActive(service, titleKey);

      return (
        <DropdownItem
          key={titleKey}
          item={{
            key: titleKey,
            title: t(langPrefixItems + titleKey),
            path: getPath(service, item),
            service: service,
            hasToShowCompanyInUrl: hasToShowCompanyInUrl && !isServiceActiveByPathname(service),
            hasIcon: hasIcon,
          }}
          isActive={isActive}
          toggle={preventDefaultLinks ? voidLinkAction : () => {}}
          companyId={companyId}
          isEmBlue={isEmBlue}
        />
      );
    });
  };

  const getActionButton = () => {
    return (
      <li>
        <a
          className="md__button--ghost upgrade__button"
          href="#"
          target="_blank"
          data-url={getProductsURL()}
          data-bypass={true}
          onClick={linkActionNewTarget}
          title={t('globalSidebar.actions.contract')}
        >
          {t('globalSidebar.actions.contract')}
        </a>
      </li>
    );
  };

  const hasToshowActionButton = menu => {
    return checkGlobalService(menu.serviceItem) && !menu.isActive;
  };

  return (
    (!isEmBlue || (isEmBlue && !hasToshowActionButton(menuBlock))) && (
      <Dropdown
        id={menuBlock.service}
        title={t(langPrefix + 'title')}
        icon={<i className={menuBlock.icon} />}
        isOpen={isServiceActiveByPathname(menuBlock.service) || isEmBlue}
        isActive={menuBlock.isActive}
        expandSidebar={expandSidebar}
        isEmBlue={isEmBlue}
      >
        {hasToshowActionButton(menuBlock) ? getActionButton() : getMenuItems()}
      </Dropdown>
    )
  );
};

MenuElement.propTypes = {
  menuBlock: PropTypes.shape({
    service: PropTypes.string.isRequired,
    hasToShowCompanyInUrl: PropTypes.bool.isRequired,
    icon: PropTypes.string.isRequired,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        titleKey: PropTypes.string.isRequired,
        path: PropTypes.string.isRequired,
      })
    ).isRequired,
    isActive: PropTypes.bool.isRequired,
    serviceItem: PropTypes.shape({
      rolId: PropTypes.string,
      properties: PropTypes.shape({
        companies: PropTypes.array,
        type: PropTypes.string,
      }),
    }),
  }).isRequired,
  lang: PropTypes.string.isRequired,
  preventDefaultLinks: PropTypes.bool,
  expandSidebar: PropTypes.func,
  companyId: PropTypes.string,
  isEmBlue: PropTypes.bool,
};

export default MenuElement;
